import React from "react";
import { withRouter } from "react-router-dom";
import PoemLine from './PoemLine';
import {
  CardDeck,
  Row,
  Col,
  Input,
  Card,
  Button,
  CardTitle,
  CardText,
  CardImg,
  CardBody,
  Collapse,
  UncontrolledCollapse,
  Badge,
  Container 
} from "reactstrap";
import { BrowserRouter, Route, Link } from "react-router-dom";

import { DebounceInput } from "react-debounce-input";

import PoemDescriptionDialog from "./PoemDescriptionDialog";
import { filterByQafiyat, filterByQuery, loadingAction} from './PoemsListReducer';
import { connect } from 'react-redux'
import LoadingSpinner from './LoadingSpinner'
import createHistory from "history/createBrowserHistory"
  

class PoemsList extends React.Component {
  constructor() {
    super();
    this.state = {
      showPoemDescription: null,
    };
    this.showPoemDescription = this.showPoemDescription.bind(this);
    this.dialogClosed = this.dialogClosed.bind(this);
    this.filterByQuery = this.filterByQuery.bind(this);
    this.getPoemDate = this.getPoemDate.bind(this);
    this.getUniqueQafiyat = this.getUniqueQafiyat.bind(this);
    this.filterByQafiyatId = this.filterByQafiyatId.bind(this);
    this.renderData = this.renderData.bind(this);
    this.getSearchLinesForPoem = this.getSearchLinesForPoem.bind(this);
    this.showPoem = this.showPoem.bind(this);
  }
  componentDidMount() {
    if(this.props.poems === null) {
    this.props.dispatch(loadingAction());
    }
  }

  getSearchLinesForPoem(poemId) {
    const result = this.props.searchResults.result.filter(poem => poem.poemId === poemId).map(poem => poem.lines);
    return result[0];
  }

  getUniqueQafiyat(poems) {
    const quafiyatList = poems.map(poem => {
      return { id: poem.letterId, name: poem.letter };
    });
    let quafiyatListSet = [];
    quafiyatList.forEach(qafiya => {
      quafiyatListSet[qafiya.id] = qafiya;
    });
    return quafiyatListSet;
  }
  filterByQuery(event) {
    var query = event.target.value;
    // this.setState({ query: query });
    this.props.dispatch(filterByQuery(query));

  }

  filterByQafiyatId(event) {

    this.props.dispatch(filterByQafiyat(event.target.value));
      // this.setState({filterByQafiyatId:event.target.value});
  }

  dialogClosed() {
    this.setState({ showPoemDescription: null });
  }
  showPoemDescription(poem) {
    this.setState({
      showPoemDescription: {
        poemTitle: poem.poemTitle,
        description: poem.description
      }
    });
  }

  getPoemDate(poem) {
    if (poem.startYear === undefined && poem.endYear === undefined) {
      return "-";
    }
    if (poem.startYear === poem.endYear) {
      return poem.startYear + " ميلادية";
    }
    return poem.startYear + "-" + poem.endYear + " ميلادية";
  }

  showPoem(poemId) {
    this.props.history.push("/poem/" + poemId)
  }

  render() {
    if(this.props.loading) {
      return <LoadingSpinner visible={true}/>;
    }

    return this.renderData();
    return               <Link to="/poem">القصائد</Link>

  }


  renderData() {
    let filteredPoems = [...this.props.poems];
    if (this.props.query !== "") {
      const filteredPoemIds = this.props.searchResults.result.map(poem => poem.poemId);
      filteredPoems = filteredPoems.filter(poem => filteredPoemIds.indexOf(poem.poemId) !== -1);
    }

    if(this.props.filterByQafiyatId !== "") {
        const qafiyatId = parseInt(this.props.filterByQafiyatId);
        filteredPoems = filteredPoems.filter(poem => poem.letterId === qafiyatId);
    }

    return (
      <div>
      <Container>
      <Row>
      <Col xs="9">
      <DebounceInput
            type="text"
            className="form-control"
            placeholder="بحث"
            minLength={2}
            debounceTimeout={800}
            onChange={this.filterByQuery}
            value={this.props.query}
          />
          </Col>
          <Col xs="3">
          <Input type="select" name="select" id="exampleSelect" onChange={this.filterByQafiyatId}>
            <option value="">كل القوافي</option>
            {this.props.quafiyatList.map(qafiya => (
              <option value={qafiya.id}>{qafiya.name}</option>
            ))}
          </Input>
          </Col>
          </Row>

          </Container>
          {!this.props.query && <PoemsCard getPoemDate={this.getPoemDate} filteredPoems={filteredPoems} showPoemDescription={this.showPoemDescription} showPoem={this.showPoem}/>}
          {this.props.query && <PoemsSearchResults getSearchLinesForPoem={this.getSearchLinesForPoem} getPoemDate={this.getPoemDate} filteredPoems={filteredPoems} showPoemDescription={this.showPoemDescription} showPoem={this.showPoem}/>}
        {this.state.showPoemDescription && (
          <PoemDescriptionDialog
            {...this.state.showPoemDescription}
            dialogClosed={this.dialogClosed}
          />
        )}
      </div>
    );
  }
}

class  PoemsSearchResults extends React.Component {
  render() {
    return <div>
    <br/><br/>
    <center>
    {this.props.filteredPoems.map((poem, index) => (
      <div style={{textAlign:'center',backgroundColor:'#F0F0F0',borderRadius:'15px',padding:'10px',marginBottom:'15px'}}>
      <b>{poem.poemTitle}</b>
      <br/>
      <br/>
    {this.props.getSearchLinesForPoem(poem.poemId).map(line => <PoemLine line={line} matchingSearchWords={line.matchingSearchWords} />)}
<br/>
    <Button
    size="sm"
    outline
    color="success"
    onClick={() => this.props.showPoemDescription(poem)}
  >
    مناسبة القصيدة
  </Button>

&nbsp;
<Button outline size="sm" color="primary"
onClick={() => this.props.showPoem(poem.poemId)}
>
  القصيدة
</Button>

    </div>
  ))}
    </center>
    </div>
  }
}

  const PoemsCard = ({getPoemDate, filteredPoems,showPoemDescription,showPoem }) => <CardDeck>
{filteredPoems.map((poem, index) => (
  <Card>
    <CardBody>
      <CardTitle>{poem.poemTitle} </CardTitle>
      <CardText>
        تاريخ القصيدة: {getPoemDate(poem)}
        <br />
        القافية: {poem.letter}
        <br />
        عدد ا[لأبيات: {poem.linesCount}
        <br />
        عدد الشروحات: {poem.explanationsCount}
        <br />
      </CardText>

      <div style={{ textAlign: "left" }}>
        {poem.descriptionExists && (
          <Button
            size="sm"
            outline
            color="success"
            onClick={() => showPoemDescription(poem)}
          >
            مناسبة القصيدة
          </Button>
        )}
        &nbsp;
        <Button outline size="sm" color="primary"
        onClick={() => showPoem(poem.poemId)}
        >
          القصيدة
        </Button>
      </div>
    </CardBody>
  </Card>
))}
</CardDeck>


function mapStateToProps(state) {
  return {...state.poems};
}

export default connect(mapStateToProps)(withRouter(PoemsList));


// WEBPACK FOOTER //
// ./src/PoemsList.js